import { render, staticRenderFns } from "./Table_news_ipos.vue?vue&type=template&id=65e21a67&"
import script from "./Table_news_ipos.vue?vue&type=script&lang=js&"
export * from "./Table_news_ipos.vue?vue&type=script&lang=js&"
import style0 from "./Table_news_ipos.vue?vue&type=style&index=0&id=65e21a67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports